import React, { useState } from 'react';

import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

import AttachmentsModal from 'bundles/apex/tasks/attachment_modal';
import ClickableIcon from 'components/clickable_icon';

import type { Attachment, Task } from 'bundles/apex/tasks/types';

interface Props {
  addTaskAttachment: (task: Task, attachment: Attachment) => void;
  attachmentsPath: string;
  deleteTaskAttachment: (task: Task, attachment: Attachment) => void;
  features?: {
    taskAttachmentExceptions?: boolean;
  };
  task: Task;
  onUpdate: (task: Task) => void;
}

export default function Status({
  addTaskAttachment,
  attachmentsPath,
  deleteTaskAttachment,
  features,
  task,
  onUpdate,
}: Props) {
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);

  function onModalSave(task) {
    onUpdate({
      ...task,
      completed: task.attachments.length > 0 || !!task.attachmentExceptionReason,
    });
  }

  function onModalHide() {
    onModalSave(task);
    setShowAttachmentsModal(false);
  }

  function toggleComplete() {
    if (
      !task.completed && task.requiresAttachment && task.attachments.length === 0 &&
      (!features?.taskAttachmentExceptions || !task.attachmentExceptionReason)
    ) {
      setShowAttachmentsModal(true);
    } else {
      onUpdate({ ...task, completed: !task.completed });
    }
  }

  return <>
    <ClickableIcon
      icon={task.completed ? faCircleCheck : faCircle}
      size="lg"
      onClick={toggleComplete}
    />

    <AttachmentsModal
      addTaskAttachment={attachment => addTaskAttachment(task, attachment)}
      attachmentExceptions={features?.taskAttachmentExceptions}
      attachmentsPath={attachmentsPath}
      deleteTaskAttachment={attachment => deleteTaskAttachment(task, attachment)}
      show={showAttachmentsModal}
      task={task}
      onHide={onModalHide}
      onSave={onModalSave}
    />
  </>;
}
